<template>
  <card-block>
    <spinner-block v-model="dataProgress">
      <template v-if="data">
        <card-header>
          <router-link :to="{name: 'client.list'}">Клиенты</router-link><!--
                    -->:
          <span class="text-secondary">#{{ data.id }}</span>
          {{ data.phone ? data.phone : '—' }} {{ data.initials ? data.initials : '—' }}
        </card-header>
        <tab-list>
          <tab-link to="client.detail">Личные данные</tab-link>
          <tab-link to="client.documents" v-if="can('module.client_document.view')">Документы</tab-link>
          <tab-link to="client.client-calls" v-if="can('module.client_call.view')">Вызовы</tab-link>
          <tab-link to="client.subscribe-chain" v-if="can('module.subscription_chain.view')">Цепочки подписок</tab-link>
          <tab-link to="client.subscribe" v-if="can('module.subscription.view')">Периоды подписок</tab-link>
          <tab-link to="client.relatives" v-if="can('module.client.relative-view')">Родственники</tab-link>
          <tab-link to="client.payments" v-if="can('module.payment.view')">Платежи</tab-link>
          <tab-link to="client.phone-calls" v-if="can('module.phone_call.view')">Телефонные звонки</tab-link>
          <tab-link to="client.cards" v-if="can('module.client.card-view')">Карты</tab-link>
          <tab-link to="client.promocode-use" v-if="can('module.promocode.view')">Промокоды</tab-link>
        </tab-list>
        <card-body>
          <router-view :key="id" :data="data" @change="getData"></router-view>
        </card-body>
      </template>
    </spinner-block>
  </card-block>
</template>

<script>
export default {
  data: function () {
    return {
      data: null,
      dataProgress: true,
    }
  },
  props: {},
  computed: {
    id() {
      return this.$route.params.id;
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      if (this.id) {
        axiosGetValue('/api/admin/client/get', {id: this.id}, e => this.data = e, e => this.dataProgress = e)
      }
    },
  },

}
</script>
